import React from "react";
import Layout from "./pageLayout.comp";
import ServiceFeatures from "../home/ServiceFeatures.comp";
import FooterNavigation from "../home/FooterNavigation.comp";
import FloatingIcons from "../home/FloatingIcons.comp";
import { Toaster } from "react-hot-toast";
import HeaderContainer from "../home/HeaderContainer";

interface MainLayoutProps {
  children: React.ReactNode;
  title: string;
  url?: string;
  description?: string;
}

function MainLayout({ children, title, url, description = "" }: MainLayoutProps) {
  // const mainSliderRef = useRef<HTMLDivElement>(null);
  // const [showStickyHeader, setShowStickyHeader] = useState(false);
  // const [isMobile, setIsMobile] = useState(false);
  // const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Use the Guru context to access user state and Guru Dollar information
  // const { isLoggedIn, refreshUserSession } = useGuru();

  // Handle mobile detection
  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth < 768);
  //   };

  //   handleResize();
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // Handle scroll for sticky header
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (!ticking) {
  //       window.requestAnimationFrame(() => {
  //         if (mainSliderRef.current) {
  //           const sliderRect = mainSliderRef.current.getBoundingClientRect();
  //           const scrollPosition = window.scrollY;
  //           setShowStickyHeader(scrollPosition > sliderRect.height && scrollPosition > 0);
  //         }
  //         ticking = false;
  //       });
  //       ticking = true;
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // const handleMobileMenuToggle = (isOpen: boolean) => {
  //   setIsMobileMenuOpen(isOpen);
  // };

  return (
    <>
      <Toaster />

      <Layout title={title} url={url} description={description}>
        <div className="overflow-x-hidden w-full">
          <div className="relative w-full mx-auto">
            <div>
              <HeaderContainer />
            </div>

            {/* Sticky Header */}
            {/* {showStickyHeader && (
              <div className="relative z-30">
                <StickyHeader
                  shouldHide={!showStickyHeader}
                  SearchBar={<SearchBar menuOpen={isMobileMenuOpen} />}
                  isMobileMenuOpen={isMobileMenuOpen}
                />
              </div>
            )} */}

            {/* Main Content */}
            {children}

            {/* Service Features Section - Simplified structure */}
            <ServiceFeatures />

            <FooterNavigation />

            {/* Floating Icons */}
            <div className="relative z-40">
              <FloatingIcons />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default MainLayout;
